import React from 'react';
import { RichTextEditor } from '../../components/RichTextEditor';

interface BlogPostEditorContentProps {
  title: string;
  content: string;
  excerpt: string;
  onTitleChange: (value: string) => void;
  onContentChange: (value: string) => void;
  onExcerptChange: (value: string) => void;
  onImageUpload: (file: File) => Promise<string>;
  siteId?: string;
}

export const BlogPostEditorContent: React.FC<BlogPostEditorContentProps> = ({
  title,
  content,
  excerpt,
  onTitleChange,
  onContentChange,
  onExcerptChange,
  onImageUpload,
  siteId,
}) => {
  return (
    <div className="lg:col-span-2 space-y-6">
      {/* Title */}
      <div>
        <input
          type="text"
          value={title}
          onChange={e => onTitleChange(e.target.value)}
          placeholder="Post title"
          className="w-full text-3xl font-bold border-0 border-b-2 border-gray-200 focus:border-primary-500 focus:ring-0 pb-2"
        />
      </div>

      {/* Content Editor */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Content</label>
        <RichTextEditor
          content={content}
          onChange={onContentChange}
          placeholder="Write your post content here..."
          minHeight="400px"
          onImageUpload={onImageUpload}
          siteId={siteId}
        />
      </div>

      {/* Excerpt */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Excerpt
          <span className="font-normal text-gray-500 ml-1">(optional)</span>
        </label>
        <textarea
          value={excerpt}
          onChange={e => onExcerptChange(e.target.value)}
          placeholder="A short summary of your post..."
          rows={3}
          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
        />
      </div>
    </div>
  );
};
